import 'isomorphic-fetch';
import io from 'socket.io-client';

// {
//   "retcode": "0x90 0x1",
//   "retmsg": "操作成功||相片解码解码正确",
//   "errmsg": "",
//   "name": "张红叶",
//   "sex": "女",
//   "nation": "汉",
//   "born": "19881118",
//   "address": "河北省邯郸市临漳县称勾镇称勾东村复兴路25号",
//   "cardno": "130423198811184328",
//   "userlifeb": "20110330",
//   "userlifee": "20210330",
//   "police": "临漳县公安局",
//   "photobase64": "iVBORw0……AAElFTkSuQmCC",
//   "FpDescribe": "",
//   "FpData": null,
//   "CardType": "0",  //港澳台居住证此处为2
//   "EngName": "",
//   "CertVol": "01",
//   "PassID": "000000000",//港澳台居住证通行证号码
//   "IssuesTimes": "01",//港澳台居住证签发次数
//   "frontImg": "",
//   "backImg": ""
// }

//公共解码方法  
function decode(input){ 
    // private property  
    let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;  
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");  
    while (i < input.length) {  
        enc1 = keyStr.indexOf(input.charAt(i++));  
        enc2 = keyStr.indexOf(input.charAt(i++));  
        enc3 = keyStr.indexOf(input.charAt(i++));  
        enc4 = keyStr.indexOf(input.charAt(i++));  
        chr1 = (enc1 << 2) | (enc2 >> 4);  
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);  
        chr3 = ((enc3 & 3) << 6) | enc4;  
        output = output + String.fromCharCode(chr1);  
        if (enc3 != 64) {  
            output = output + String.fromCharCode(chr2);  
        }  
        if (enc4 != 64) {  
            output = output + String.fromCharCode(chr3);  
        }  
    }  
    output = utf8Method(output);  
    return output;  
}  

//UTF-8解码的专用方法
function utf8Method(utftext) {  
    var string = "";  
    var i = 0;  
    let c = 0;  
    let c1 = 0;  
    let c2 = 0;  
    while ( i < utftext.length ) {  
        c = utftext.charCodeAt(i);  
        if (c < 128) {  
            string += String.fromCharCode(c);  
            i++;  
        } else if((c > 191) && (c < 224)) {  
            c2 = utftext.charCodeAt(i+1);  
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));  
            i += 2;  
        } else {  
            c2 = utftext.charCodeAt(i+1);  
            let c3 = utftext.charCodeAt(i+2);  
            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));  
            i += 3;  
        }  
    }  
    return string;  
}

export const readCard = (callback) => {
    //IE10以下的socket.io仍使用轮询方式和服务器通信，轮询过程中会导致重连，暂时不清楚原因。
    //如果服务端向客户端发送数据时发生重连，大概需要3秒多客户端才能收到数据
    //这里打开io的时候设置重连等待时间尽可能短，以减少接收数据的延时。
    var socket = io.connect('http://localhost:5000',{'timeout': 300000,'reconnectionDelayMax':1000,'reconnectionDelay':500});
    
    //localStorage.debug = '*';
    socket.on('connect',  () =>{
        socket.emit('startRead');
    });
    socket.on('disconnect',  () =>{
    });
        
    //错误信息
    socket.on('error message', (msg) =>{
        console.log('error:'+msg)
    });
    
    return  {
        start:()=>{
            console.log('开始读卡')
            socket.emit('startRead');
            socket.on('card message', (msg)=>{
                //2.解密后是json字符串
                let data = eval("("+decode(msg)+")"); 
                if (typeof callback === 'function') {
                    callback(data);
                }
            });
        },
        check:()=>{
            socket.emit('isReading','', (data)=>{
                console.log('isReading: ' + data)
            });
        },
        stop:()=>{
            console.log('停止读卡')
            socket.emit('stopRead');
            socket.on('card message', (msg)=>{
                //2.解密后是json字符串
                let data = eval("("+decode(msg)+")"); 
                if (typeof callback === 'function') {
                    callback(data);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./utils/readCard.js